import { ReactElement } from "react";
import { WebsiteLayout } from "./WebsiteLayout";

/**
 * Landing pages: website footer without the top logo header.
 */
export function getLandingLayout(page: ReactElement) {
  return (
    <WebsiteLayout showHeader={false}>
      <main className="page-main landing-page">
        <div className="page-main-inner">{page}</div>
      </main>
    </WebsiteLayout>
  );
}
